document.addEventListener("DOMContentLoaded", () => {
  const sections = document.querySelectorAll(".technology-comparison");

  sections.forEach((section) => {
    let animated = false;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (!entry.isIntersecting || animated) return;

          animated = true;

          const fills = section.querySelectorAll(".technology-progress__fill");

          fills.forEach((fill) => {
            const target = parseInt(fill.dataset.width, 10);

            const number = fill
              .closest(".technology-progress")
              .querySelector(".technology-progress__number");

            // Animate the bar
            fill.style.width = target + "%";

            // Animate the number
            let current = 0;
            const duration = 1500;
            const increment = target / (duration / 16);

            const timer = setInterval(() => {
              current += increment;

              if (current >= target) {
                current = target;
                clearInterval(timer);
              }

              number.textContent = Math.round(current) + "%";
            }, 16);
          });

          observer.unobserve(section);
        });
      },
      {
        threshold: 0.3,
      },
    );

    observer.observe(section);
  });
});
